export default {
  content: {
    id: 'product_seller_details_modal_no_info_content',
    defaultMessage:
      'The seller hasn’t given Back Market this information yet. ',
  },
  title: {
    id: 'product_seller_details_modal_no_info_title',
    defaultMessage: 'This info will be displayed shortly.',
  },
}
